var _a;
import { EXTERNAL_ROUTES, IMAGE_BASE_URL } from '../../../constants/values';
import { QuizPageStrings } from './QuizStrings';
var questions = QuizPageStrings.questions, recommendations = QuizPageStrings.recommendations;
var QuizQuestionId = {
    whereIsTeam: 'whereIsTeam',
    howOften: 'howOften',
    workEmail: 'workEmail',
};
export var WhereIsTeamResponseId = {
    remote: 'remote',
    inOffice: 'inOffice',
    hybrid: 'hybrid',
};
var WhereIsTeamQuestionData = {
    id: QuizQuestionId.whereIsTeam,
    question: questions.whereIsTeam.question(),
    options: [
        {
            id: WhereIsTeamResponseId.remote,
            title: questions.whereIsTeam.option1.title(),
            subtitle: questions.whereIsTeam.option1.subtitle(),
            url: IMAGE_BASE_URL + "/s/managed/consumer/teams/on-laptop.png",
        },
        {
            id: WhereIsTeamResponseId.inOffice,
            title: questions.whereIsTeam.option2.title(),
            subtitle: questions.whereIsTeam.option2.subtitle(),
            url: IMAGE_BASE_URL + "/s/managed/consumer/teams/in-office-work.png",
        },
        {
            id: WhereIsTeamResponseId.hybrid,
            title: questions.whereIsTeam.option3.title(),
            subtitle: questions.whereIsTeam.option3.subtitle(),
            url: IMAGE_BASE_URL + "/s/managed/consumer/teams/hybrid-work.png",
        },
    ],
};
export var HowOftenResponseId = {
    oneTime: 'oneTime',
    monthly: 'monthly',
    weeklyOrMore: 'weeklyOrMore',
};
var HowOftenQuestionData = {
    id: QuizQuestionId.howOften,
    question: questions.howOften.question(),
    options: [
        {
            id: HowOftenResponseId.oneTime,
            title: questions.howOften.option1.title(),
        },
        {
            id: HowOftenResponseId.monthly,
            title: questions.howOften.option2.title(),
        },
        {
            id: HowOftenResponseId.weeklyOrMore,
            title: questions.howOften.option3.title(),
        },
    ],
};
var WorkEmailQuestionData = {
    id: QuizQuestionId.workEmail,
    question: questions.workEmail.question(),
    email: {
        label: questions.workEmail.label(),
    },
};
export var QuizQuestionsData = [
    WhereIsTeamQuestionData,
    HowOftenQuestionData,
    WorkEmailQuestionData,
];
var CateringProduct = {
    title: recommendations.catering.title(),
    subtitle: recommendations.catering.subtitle(),
    body: [
        {
            title: recommendations.catering.body1.title(),
            bullets: [
                recommendations.catering.body1.bullet1(),
                recommendations.catering.body1.bullet2(),
            ],
        },
        {
            title: recommendations.catering.body2.title(),
            bullets: [
                recommendations.catering.body2.bullet1(),
                recommendations.catering.body2.bullet2(),
                recommendations.catering.body2.bullet3(),
            ],
        },
    ],
    button: {
        text: recommendations.catering.buttonText(),
        link: EXTERNAL_ROUTES.CATERING_NEAR_ME,
    },
    imageUrl: IMAGE_BASE_URL + "/s/managed/consumer/teams/catering.png",
};
var ExpensedMealsProduct = {
    title: recommendations.expensedMeals.title(),
    subtitle: recommendations.expensedMeals.subtitle(),
    body: [
        {
            title: recommendations.expensedMeals.body1.title(),
            bullets: [
                recommendations.expensedMeals.body1.bullet1(),
                recommendations.expensedMeals.body1.bullet2(),
                recommendations.expensedMeals.body1.bullet3(),
            ],
        },
        {
            title: recommendations.expensedMeals.body2.title(),
            bullets: [
                recommendations.expensedMeals.body2.bullet1(),
                recommendations.expensedMeals.body2.bullet2(),
            ],
        },
    ],
    pricing: {
        title: recommendations.expensedMeals.pricing.title(),
        subtitle: recommendations.expensedMeals.pricing.subtitle(),
    },
    button: {
        text: recommendations.expensedMeals.buttonText(),
    },
    imageUrl: IMAGE_BASE_URL + "/s/managed/consumer/teams/ordering.png",
};
export var ProductOffering = {
    catering: 'catering',
    expensedMeals: 'expensedMeals',
};
export var RecommendedProducts = (_a = {},
    _a[ProductOffering.catering] = CateringProduct,
    _a[ProductOffering.expensedMeals] = ExpensedMealsProduct,
    _a);
